<template>
  <li class="menu__item">
    <div class="pos-rel">
      <router-link
        v-if="item.linkTo"
        :to="{
          name: item.linkTo,
          ...(item.id && { params: { [item.linkTo + 'Id']: item.id }})
        }"
        class="menu__link">
        {{ item.linkText }}
      </router-link>
      <span v-else>{{ item.name }}</span>
      <span v-if="isFolder" @click="toggle">
        <i class="el-icon-arrow-down menu__arrow" :class="{ 'menu__arrow--open': isOpen }" />
      </span>
      <el-badge
        v-if="item.notifications && item.notifications.length"
        :value="item.notifications.length"
        class="d-inline-flex"
        type="success" />
    </div>
    <el-collapse-transition>
      <ul v-show="isOpen" class="menu__submenu">
        <nav-tree-item
          v-for="child in item.children"
          :key="child.id || child.linkTo"
          class="menu__item"
          :item="child" />
      </ul>
    </el-collapse-transition>
  </li>
</template>

<script>
  export default {
    name: 'NavTreeItem',

    props: {
      item: Object
    },

    data() {
      return {
        isOpen: false
      }
    },

    computed: {
      isFolder() {
        return this.item && this.item.children &&
          this.item.children.length
      }
    },

    methods: {
      toggle(event) {
        if (this.isFolder) {
          this.isOpen = !this.isOpen
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .menu__submenu {
    padding-left: 16px;
  }

  .menu__item {
    padding-top: 12px;
  }

  .menu__link {
    &:hover,
    &.router-link-exact-active {
      color: $primary-color;
    }
  }

  .menu__arrow {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 3px;
    z-index: 0;
    margin: 0;
    transition: transform .3s;
    font-weight: bold;
    &--open {
      transform: rotate(-90deg);
      transition: transform .3s;
    }
    &:hover {
      color: $primary-color;
    }
  }
</style>
